<template>
  <div class="good-needs-main" :class="{ 'good-needs-main-mobile': isMobile}">
    <GoodNeedsItem v-for="item in dataList" :key="item.key" :data="item"></GoodNeedsItem>
  </div>
</template>
<script>
  export default {
    // 优势 愿景
    name: 'GoodNeeds',
    data() {
      return {
        dataList: [
          {
            title: '客户至上，自主可控',
            content:
              '我们支持您通过简单易行的快捷方式实现自主控制应用使用的权限，如：您可一键开启电话免打扰保护，一键关闭个性化推荐等，守护您的个人信息安全。',
            icon: require('@/assets/images/homePage/customer-up.png'),
            bgImage: 'rgba(2, 115, 245, 0.1)',
            key: 'customer'
          },
          {
            title: '合法合规，公开透明',
            content:
              '我们会通过隐私政策、隐私产品、增强告知等方式主动告知您收集和使用个人信息的规则，只在获得同意后，才会收集和使用您的个人信息。同时，您可以随时查询、修改、删除产品与服务中的个人信息。',
            icon: require('@/assets/images/homePage/open-transparent.png'),
            bgImage: 'rgba(255,255,255,1)',
            className: 'custom-class',
            key: 'transparent'
          },
          {
            title: '安全可靠，合理必要',
            content:
              '我们通过专业机构和安全专家认证认可的安全保护机制来保护您的数据安全，并且仅手机必要的个人信息。如：您的好吗会被严格加密，通过虚拟中间号联系经纪人。',
            icon: require('@/assets/images/homePage/safe-reliable.png'),
            bgImage: 'rgba(2, 115, 245, 0.1)',
            key: 'reliable'
          }
        ]
      };
    }
  };
</script>
<style lang="scss" scoped>
  .good-needs-main {
    margin-top: 0.96rem;
    width: 100%;
  }
  .good-needs-main-mobile {
    margin-top: -1.3rem;
  }
</style>
